export default class ActiveURLHashManager {
    static instance = new ActiveURLHashManager;

    hash = ko.observable(this.getHash());

    constructor() {
        $(window).on('hashchange', () => this.hash(this.getHash()));
    }

    private getHash() {
        return location.hash.substring(1);
    }
}